<template>
  <div class="d-flex flex-column flex-center text-center p-10">
    <div class="card card-flush w-lg-650px py-5">
      <div class="card-body py-15 py-lg-20">
        <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
        <div class="fw-semibold fs-6 text-gray-500 mb-7">Извините, но страница которую вы ищете не найдена. Попробуйте проверить URL-адрес на наличие ошибок,
          затем нажмите кнопку обновления в своем браузере или попробуйте найти что-нибудь еще в нашем сайте.</div>
        <div class="mb-0">
          <router-link :to="{ name: 'Orders' }" class="btn btn-sm btn-primary">На главную</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>

</style>